import { useTranslation } from "react-i18next";
import { isAdvanceNoticeError } from "~/utils/apiErrorMessages";
import { isProfessionalWithNoAgendaError } from "~/utils/checkout/errorsValidation";
import { mixpanelTrackEvent } from "~/utils/mixpanel";

export const useCheckoutBookingErrorHandler = ({
    effectiveServices,
    markServiceAsExpired,
    findNoAgendaServiceIndex,
    eventProps,
    currentUser,
    business,
    services,
    valorAgendamento,
    showApiError,
}) => {
    const { t } = useTranslation();

    // Retorna true se o erro foi tratado, false se deve cair no dialog genérico
    const handleBookingError = (err, message) => {
        if (isAdvanceNoticeError(err) && effectiveServices.length === 1) {
            markServiceAsExpired(0);
            return true;
        }
        if (isProfessionalWithNoAgendaError(message)) {
            mixpanelTrackEvent("Erro_Profissional_Nao_Tem_Agenda", eventProps, currentUser, business);
            markServiceAsExpired(findNoAgendaServiceIndex(message), t("professionalNoAgendaCardTitle"));
            return true;
        }
        if (err.__handled__) return true;
        return showApiError(err, null, null, { services, valor_agendamento: valorAgendamento });
    };

    return { handleBookingError };
};
